var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 9.99995C12.1486 9.99995 13.8888 8.25967 13.8888 6.11106C13.8888 3.96245 12.1486 2.22217 9.99995 2.22217C7.85133 2.22217 6.11106 3.96245 6.11106 6.11106C6.11106 8.25967 7.85133 9.99995 9.99995 9.99995ZM9.99995 11.9444C7.40411 11.9444 2.22217 13.2472 2.22217 15.8333V17.7777H17.7777V15.8333C17.7777 13.2472 12.5958 11.9444 9.99995 11.9444Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/audience.43535adc42a556113441037024c14436.svg";
export { ForwardRef as ReactComponent };